module.exports = __webpack_public_path__ + "media/images/BG2_features-a14c72c8.png";